export default __webpack_public_path__ + "static/pro@mob_2x-c9eaea7bcac122f8a3527581aa02538b.jpg";